var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-center transaction-details"},[_c('h1',[_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}})]),_c('div',{attrs:{"id":"wrap-content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }